// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"300465c7","84":"4e9e1acd","439":"8ccc426f","453":"64aababc","493":"0860e15e","530":"e581e511","614":"13fa0acb","886":"7a836529","973":"082b22ab"}[chunkId] + ".chunk.js";
};